import { Dropdown, Popover } from "antd";
import { useCallback, useMemo, useEffect, useState } from "react";
import { Icon } from "@terminus/dqh-web-ui";
// import { useLocation } from 'react-router-dom';
import { useCurrent } from "@/providers";
// import { getCarbonConfig } from '@/services';
import style from "./style.module.scss";
import { UserCard } from "./user-card";
import { useNavigate } from "react-router-dom";

export type TopHeadProps = {};

export const GypTopHead = () => {
  const { isLogin, role, current } = useCurrent();
  const [isShowTop, setIsShowTop] = useState(false);

  // 根据当前时间获取问候语
  const getGreeting = useCallback(() => {
    const hour = new Date().getHours();
    if (hour >= 6 && hour < 10) {
      return "早上好";
    } else if (hour >= 10 && hour < 13) {
      return "中午好";
    } else if (hour >= 13 && hour < 18) {
      return "下午好";
    } else if (hour >= 18 && hour < 22) {
      return "晚上好";
    } else {
      return "深夜好";
    }
  }, []);

  const handleLogin = useCallback(() => {
    if (isLogin) {
      return;
    }

    window.location.href = `${
      process.env.LOGIN_URL
    }?gotoUrl=${encodeURIComponent(window.location.href)}`;
  }, [isLogin]);

  const helpCenter = useMemo(() => {
    return (
      <>
        <span
          className={style.headerDropdown}
          style={{ cursor: "pointer" }}
          onClick={() =>
            (window.location.href = `${process.env.GYPS_HOME}/buyer/orders`)
          }
        >
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ marginRight: 4 }}>我的订单</span>
          </div>
        </span>
        <span className={style.headerLine} />
        <span>0571-26883999（工作日9:00-18:00）</span>
      </>
    );
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 100) {
        setIsShowTop(true);
      } else {
        setIsShowTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const rightAffix = useMemo(() => {
    const askContent = (
      <div style={{ display: "flex" }}>
        <div className={style.askContent}>
          <img
            src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihuiweix.png"
            alt="大企汇微信公众号"
          />
          <span>微信扫码咨询</span>
        </div>
        <div className={style.askContent}>
          <img
            src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/dingding_qr.png"
            alt="钉钉扫码"
          />
          <span>钉钉扫码咨询</span>
        </div>
      </div>
    );

    const followContent = (
      <div className={style.askContent}>
        <img
          src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/wx_qr.png"
          alt="关注我们"
        />
        <span>大企汇</span>
        <span>微信公众号</span>
      </div>
    );
    return (
      <div className={style.rightAffix}>
        <div
          className={style.rightAffixItem}
          onClick={() => {
            window.open(
              "https://help.daqihui.com/1.0/manual/quick-start/qcs/buy-service.html",
            );
          }}
        >
          <div className={style.help}></div>
        </div>
        <div className={style.rightAffixItem}>
          <Popover content={askContent} placement="rightTop">
            <div className={style.ask}>
              <img
                src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/advice.png"
                alt="钉钉扫码"
              />
              <span>在线咨询</span>
            </div>
          </Popover>
        </div>
        <div className={style.rightAffixItem}>
          <Popover content={followContent} placement="rightTop">
            <div className={style.follow}></div>
          </Popover>
        </div>
        {isShowTop && (
          <div
            className={style.rightAffixItem}
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          >
            <div className={style.top}></div>
          </div>
        )}
      </div>
    );
  }, [isShowTop]);

  return (
    <>
      {!isLogin ? (
        <div className={style.headerWrapper}>
          <div className={style.headerLeft}>
            <span style={{ marginRight: 8 }}>欢迎来到大企汇工业品商城</span>
            {isLogin ? null : (
              <a
                onClick={handleLogin}
                style={{ marginRight: 8, color: "#FF5600" }}
                className={style.linkPrimary}
              >
                请登录
              </a>
            )}
          </div>
          <div className={style.headerRight}>
            <a className={style.linkDefault} href={`${process.env.YCX_HOME}`}>
              商城首页
            </a>
            <span className={style.headerLine} />
            {helpCenter}
          </div>
        </div>
      ) : (
        <div className={style.headerWrapper}>
          <div className={style.headerLeft}>
            <span
              className={style.headerDropdown}
              onClick={(e) => e.preventDefault()}
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <span
                  style={{
                    marginRight: 0,
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {current?.account || "-"}
                </span>
                <span style={{ marginRight: 8 }}>欢迎来到大企汇工业品商城</span>
              </div>
            </span>
          </div>
          <div className={style.headerRight}>
            <a className={style.linkDefault} href={`${process.env.GYPS_HOME}`}>
              商城首页
            </a>
            <span className={style.headerLine} />
            {helpCenter}
          </div>
        </div>
      )}
      {rightAffix}
    </>
  );
};
